import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/Fonts.ts\",\"import\":\"Inter\",\"arguments\":[{\"variable\":\"--font-inter\",\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/Fonts.ts\",\"import\":\"Gloock\",\"arguments\":[{\"weight\":\"400\",\"variable\":\"--font-gloock\",\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"gloock\"}");
;
import(/* webpackMode: "eager", webpackExports: ["K33Footer"] */ "/app/web/src/components/K33/K33Footer.tsx");
;
import(/* webpackMode: "eager" */ "/app/web/styles/global.scss");
